export default "__VITE_ASSET__24454434__"